import Typography from '@/common/Typography'
import Button from '@/common/button'
import { useNavigate } from 'react-router'

const UnauthorizedPage = () => {
  const navigate = useNavigate()

  const handleCancelClick = () => {
    window.location.reload()
  }
  return (
    <div className='w-full h-[100vh]  px-8 flex flex-col xl:flex-row gap-16 items-center justify-center '>
      <div className='w-full flex flex-col md:items-center'>
        <div className='flex flex-col gap-4'>
          <div className='flex md:justify-center'>
            <Typography className='text-[#535C5F] text-[80px] text-[#8DA0A5] md:text-[142px] lg:text-[160px] font-light'>
              Sorry...
            </Typography>
          </div>
        </div>
      </div>
      <div className='w-full flex flex-col md:items-center  gap-8'>
        <div className=' md:w-[424px] flex flex-col gap-4'>
          <Typography className='text-[#535C5F] text-[14px] md:text-[18px] lg:text-[28px] font-light'>
            You cannot perform this action or view this page.
          </Typography>
          <Typography className='text-[#535C5F] text-[14px] md:text-[18px] lg:text-[28px] font-light'>
            This is because you do not have permission for this action or to
            view this page, contact your admin for access.
          </Typography>
        </div>
        <div className='w-full  md:w-[424px] flex flex-col md:flex-row gap-4'>
          <Button
            variant='cancel'
            className='!uppercase w-full  h-[48px]  md:w-[203px] bg-[#F7F7F7] text-point-primary-text whitespace-nowrap'
            label='Go Back'
            onClick={handleCancelClick}
          />
          <Button
            onClick={() => navigate('/')}
            className='!uppercase w-full  h-[48px]  md:w-[203px] whitespace-nowrap'
            label='Go To Homepage'
            href='/'
          />
        </div>
      </div>
    </div>
  )
}

export default UnauthorizedPage
